<i18n
  src="@/locales/views/customer/quality_control/destination/list_templates.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/quality_template.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="customer_quality_control_destination_list_containers_path"
    :params="{
      agro_exporter_id: agro_exporter_id,
      customer_id: customer_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, agro_exporter?.name, container?.container_code]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <container-info :container="container" />

    <h1 class="page-title mt-8">
      <i class="fa-solid fa-box-check"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-gray-200">
          <li
            v-for="template in exporter_process_quality_templates"
            :key="template.id"
          >
            <div
              class="block hover:bg-gray-50"
              @click="goToListQualityInspects(template)"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ template.quality_template.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link invisible sm:visible">
                      <i class="fa-solid fa-pen"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </a>
                  </div>
                </div>

                <div class="mt-2 sm:flex sm:justify-between">
                  <div class="sm:flex">
                    <p class="flex items-center text-sm text-gray-500">
                      <i
                        class="fa-solid fa-crate-apple flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span class="space-icon"></span>
                      {{ template.num_exported_batches_with_inspects }} /
                      {{ template.num_exported_batches }}
                    </p>
                    <p
                      class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                    >
                      <i
                        class="fa-solid fa-box-check flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span class="space-icon"></span>
                      {{ template.num_inspects }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/customer/requesters/quality_control/container/list_templates.js";
import ContainerInfo from "@/components/views/customer/quality_control/destination/ContainerInfo.vue";

export default {
  components: { ContainerInfo },
  name: "ListTemplates",

  props: ["customer_id", "agro_exporter_id", "container_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter: {},
      container: {},
      exporter_process_quality_templates: []
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporter();
      await this.fetchContainer();
      await this.fetchTemplates();
      this.load_data_general = true;
    },
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id
      });
      this.agro_exporter = response.data;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id
      });
      this.container = response.data;
    },
    fetchTemplates: async function () {
      let response = await Requester.fetchTemplates({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id
      });
      this.exporter_process_quality_templates = response.data;
    },
    goToListQualityInspects: function (template) {
      this.$router.push({
        name: "customer_quality_control_destination_list_inspects_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          container_id: this.container_id,
          exporter_process_quality_template_id: template.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  }
};
</script>
